import React, { Component } from "react"

class WidgetHeader extends Component {
  render() {
    return (
      <div className="col-12">
        <div className="d-flex flex-wrap">
          <div>
            <h3 className="card-title">{this.props.title}</h3>
          </div>
        </div>
      </div>
    )
  }
}

export default WidgetHeader



// WEBPACK FOOTER //
// ./src/Components/Widgets/Layout/WidgetHeader.js